import { useEffect, useState } from "react";

const DESKTOP_QUERY = "(hover: hover) and (pointer: fine)";

const getInitialMatch = (): boolean => {
  if (typeof window === "undefined" || !window.matchMedia) {
    return false;
  }
  return window.matchMedia(DESKTOP_QUERY).matches;
};

/**
 * Detects a "desktop" input surface — hover-capable + fine pointer — rather
 * than viewport width, so touch tablets (which can be wide) are excluded.
 * SSR-safe: defaults to false until the media query resolves client-side.
 */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState<boolean>(getInitialMatch);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) {
      return;
    }
    const mql = window.matchMedia(DESKTOP_QUERY);
    const handleChange = (event: MediaQueryListEvent) => {
      setIsDesktop(event.matches);
    };
    setIsDesktop(mql.matches);

    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", handleChange);
      return () => mql.removeEventListener("change", handleChange);
    }
    // Safari <14 fallback
    mql.addListener(handleChange);
    return () => mql.removeListener(handleChange);
  }, []);

  return isDesktop;
}
